
export default {
    namespaced: true,
    state: {
        googleAccountData: {},
        currentPage: 1,
        perPage: 10,
        deletedList: []
    },
    getters: {
        DELETED_LIST: state => {
            return state.deletedList;
        },
        PARAMS: state => {
            return state.params;
        },
        CATEGORY_LIST: state => {
            return state.categoryList;
        },
        GOOGLE_ACCOUNT_DATA: state => {
            return state.googleAccountData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
    },
    mutations: {
        DELETED_LIST: (state, payload) => {
            return state.deletedList = payload;
        },
        ADD_TO_DELETED_LIST: (state, payload) => {
            return state.deletedList.push(payload);
        },
        ADD_TO_GOOGLE_ACCOUNT_DATA: (state, payload) => {
            return state.googleAccountData[payload.key] = payload.value;
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        GOOGLE_ACCOUNT_DATA: (state, payload) => {
            return state.googleAccountData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        HANDLE_RESPONSE: (state, payload) => {
            let buf = {};
            for (let key in payload) {
                buf[payload[key]['id']] = payload[key]
            }

            return state.googleAccountData = buf;
        },

    },
    actions: {
        SAVE: async ({commit, state}, payload) => {
            let data = {
                list: state.googleAccountData,
                deleted: state.deletedList,
            };
            state.isSendingSAVE = true;
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/google-account',
                parameter: data,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.deletedList = [];
                    commit('HANDLE_RESPONSE', responseData.accountData);
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay --;
                }
            });
        },
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/google-account',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // add action field
                    for (let key in responseData.accountData) {
                        responseData.accountData[key].action = responseData.accountData[key].id
                    }
                    commit('HANDLE_RESPONSE', responseData.accountData);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }

    }
}